import { combineReducers } from 'redux';

import auth from './auth/reducer';
import user from './user/reducer';

const appReducer = combineReducers({
  auth,
  user,
});

const rootReducer = (state, action) => {
  // Clears all informations stored in redux
  return appReducer(action.type === 'LOGOUT' ? undefined : state, action);
};

export default rootReducer;
